import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Loader2 } from 'lucide-react';

const PaymentSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // This page is no longer used with Razorpay integration
    // Payment verification happens directly in the checkout page
    // Redirect to dashboard after a brief moment
    const timer = setTimeout(() => {
      navigate('/dashboard');
    }, 1000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-cyan-50 via-white to-teal-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <Card className="max-w-md w-full" data-testid="payment-status-card">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4">
            <Loader2 className="h-16 w-16 animate-spin" style={{ color: '#4AC5DB' }} />
          </div>
          <CardTitle className="text-2xl" style={{ fontFamily: 'Playfair Display' }}>
            Redirecting...
          </CardTitle>
          <CardDescription>
            Taking you to your dashboard
          </CardDescription>
        </CardHeader>
      </Card>
    </div>
  );
};

export default PaymentSuccess;